import { render, staticRenderFns } from "./NotificacoesSignatario.vue?vue&type=template&id=18533244"
import script from "./NotificacoesSignatario.vue?vue&type=script&lang=js"
export * from "./NotificacoesSignatario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports